import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';

@Injectable()
export class ConfirmationDialogService {
	private modalRef: NgbModalRef;
	constructor(private modalService: NgbModal) { }

	public confirm(
		title: string,
		message: string,
		btnOkText: string = 'OK',
		btnCancelText: string = 'Cancel',
		dialogSize: 'sm' | 'lg' = 'sm'
	): Promise<boolean> {
		this.modalRef = this.modalService.open(ConfirmationDialogComponent, {
			size: dialogSize,
			backdrop: 'static'
		});
		this.modalRef.componentInstance.title = title;
		// this.modalRef.componentInstance.message = '<h1>dsdfdfdsdf</h1>';
		this.modalRef.componentInstance.message = message;
		this.modalRef.componentInstance.btnOkText = btnOkText;
		this.modalRef.componentInstance.btnCancelText = btnCancelText;

		return this.modalRef.result;
	}

	public getModalRef(): NgbModalRef {
		return this.modalRef;
	}

	public dismissCurrentModal(): void {
		if (this.modalRef) {
			this.modalRef.dismiss();
		}
	}
}
